<template>
    <div>
    <h3>公司介绍</h3>
    <ul>
        <li>
            <p>
                <strong class="font16">我们是谁</strong>
            </p>
            <p style="text-indent: 20px;">
                 北京汉宁恒丰医药科技股份有限公司是一家专注于医药行业数字化服务的创新型高科技公司，面向医药生产企业、流通企业提供基于 SaaS 云服务的线上销售与管理解决方案，助力医药企业完成数字化转型。
            </p>
            <p style="text-indent: 20px;">
                 公司依托对医药流通业务的深入理解与多年行业积累，将软件能力与行业资源整合，采用“软件+产品”的创新模式，为客户的线上业务运营赋能。
                公司持有互联网药品信息服务资格，具备为医药企业网络销售业务提供系统建设、数据管理与合规支撑的服务能力。
            </p>

            <p>
                <strong class="font16">我们的服务</strong>
            </p>
            <p style="text-indent: 20px;">
                北京汉宁恒丰医药科技股份有限公司打造的低成本医药企业私域B2B电商解决方案，是面向医药流通和生产企业提供云服务线上销售及管理系统，赋予医药企业线上业务的运营能力，从而完成企业的数字化转型。
            </p>
            <p>
                <strong class="font16">我们的理念</strong>
            </p>
            <p style="text-indent: 20px;">
              北京汉宁恒丰医药科技股份有限公司始终致力于以数字技术优化国内医药供应链，帮助医药企业建立自主可控的线上业务能力，改善终端采购体验
            </p>
        </li>
    </ul>
</div>
</template>
<script>
export default {
  name: 'Introduction'
}
</script>
